module.exports = __webpack_public_path__ + "static/media/collision-detection.1d72c652.svg";